import { createApi } from '@reduxjs/toolkit/query/react'

import { staggeredBaseQueryWithBailOut } from '../libs/services'
import { unversionedApiUrl } from './common'
import { ServiceBaseUrl } from './serviceApi'

export const sessionLockApi = createApi({
	reducerPath: 'sessionLockApi',
	baseQuery: staggeredBaseQueryWithBailOut(unversionedApiUrl),
	endpoints: builder => ({
		getSessionLockStatus: builder.query<{ locked: boolean }, void>({
			query: () => ({
				url: `${ServiceBaseUrl.SessionLock}/lock-status`,
				method: 'GET',
			}),
		}),
		lockSession: builder.mutation<void, void>({
			query: () => ({
				url: `${ServiceBaseUrl.SessionLock}/lock`,
				method: 'POST',
				body: {},
			}),
		}),
		unlockSession: builder.mutation<void, void>({
			query: () => ({
				url: `${ServiceBaseUrl.SessionLock}/unlock`,
				method: 'POST',
				body: {},
			}),
		}),
	}),
})

export const {
	useGetSessionLockStatusQuery,
	useLockSessionMutation,
	useUnlockSessionMutation,
} = sessionLockApi
